angular.module('app').config(taxessRouting);

function taxessRouting($routeProvider) {
  $routeProvider.when('/taxes', {
    pageTitle: 'TAXES',
    template: '<taxes-page></taxes-page>',
    breadcrumb: {
      label: 'COMPANY_SETTINGS',
      parent: 'ng/company_settings',
    },
    accessPermission: 'index_tax_accountadmin',
    authReq: true,
  });
}

taxessRouting.$inject = ['$routeProvider'];
